import Colors from '@/constants/Colors';
import { Tag } from 'antd';

export default function LiveTag({ marginLeft }) {
  return (
    <Tag
      color={Colors.purple}
      style={{
        marginRight: 3,
        marginLeft: marginLeft ? 3 : 0,
        lineHeight: '14px',
      }}
    >
      LIVE
    </Tag>
  );
}
